import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import { Collapsible, Badge } from '@openedx/paragon';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import SequenceLink from './SequenceLink';
import { useModel } from '../../generic/model-store';

import messages from './messages';
import { ReactComponent as Open } from '../../svg/open.svg';
import { ReactComponent as Close } from '../../svg/close.svg';
import { levelIcons } from '../../config/icons';

function Section({
  sectionNumber,
  courseId,
  defaultOpen,
  expand,
  intl,
  section,
}) {
  const {
    complete,
    sequenceIds,
    title,
    lastVisited,
  } = section;
  const {
    courseBlocks: {
      sequences,
    },
  } = useModel('outline', courseId);

  const [open, setOpen] = useState(defaultOpen);

  useEffect(() => {
    setOpen(expand);
  }, [expand]);

  useEffect(() => {
    setOpen(defaultOpen);
  }, []);


  const SectionIcon = levelIcons[sectionNumber];
  const sectionTitle = (
    <div className="row w-100 m-0">
      <div className="col-auto p-0">
        {complete ? (
          <span className="course-section-serial completed">
            <FontAwesomeIcon
              icon={faCheck}
              fixedWidth
              className="float-left text-success p-2"
              aria-hidden="true"
              size="xs"
            />
          </span>
        ) : (
          <span className="course-section-serial">{SectionIcon && <SectionIcon />}</span>
        )}
      </div>
      <div className="col-auto ml-3 p-0">
        <h3 className="align-middle">{title}</h3>
        <span className="sr-only">
          ,{' '}
          {intl.formatMessage(
            complete ? messages.completedSection : messages.incompleteSection
          )}
        </span>
      </div>
      {!open && lastVisited ? (
        <div className="col-auto ml-auto">
          <span className="ml-3 align-middle">
            <Badge variant="light" className="chip" pill={true}>
              {intl.formatMessage(messages.lastVisited)}
            </Badge>
          </span>
        </div>
      ) : null}
    </div>
  );

  return (
    <li>
      <Collapsible
        className="mb-2"
        styling="card-lg"
        title={sectionTitle}
        open={open}
        onToggle={() => { setOpen(!open); }}
        iconWhenClosed={<Close />}
        iconWhenOpen={<Open />}
      >
        <ol className="list-unstyled">
          {sequenceIds.map((sequenceId, index) => (
            <SequenceLink
              key={sequenceId}
              id={sequenceId}
              courseId={courseId}
              sequence={sequences[sequenceId]}
              first={index === 0}
            />
          ))}
        </ol>
      </Collapsible>
    </li>
  );
}

Section.propTypes = {
  courseId: PropTypes.string.isRequired,
  defaultOpen: PropTypes.bool.isRequired,
  expand: PropTypes.bool.isRequired,
  intl: intlShape.isRequired,
  section: PropTypes.shape().isRequired,
};

export default injectIntl(Section);
